<script>
  import Card from '../../../components/card.svelte'
  import EntityList from '../../../components/entity/entity_list.svelte'

  let { mediaUploads } = $props()

  const records = $derived(mediaUploads?.records ?? [])
  const totalCount = $derived(mediaUploads?.total_count ?? 0)
  const shown = $derived(mediaUploads?.shown ?? 25)
</script>

<Card title="Failed Uploads">
  {#snippet actions()}
    <span class="badge badge-ghost">{totalCount}</span>
  {/snippet}

  <EntityList entity="media_upload" rows={records} density="compact" emptyMessage="No failed uploads." />

  {#if totalCount > shown}
    <p class="text-xs text-base-content/60 mt-2">Showing latest {shown} of {totalCount}.</p>
  {/if}
</Card>
